import { Form } from 'react-bootstrap'

export default function JournalEntryContainer({
  value,
  journalContent,
  handleTextAreaChange
}) {
  return (
    <Form.Control
      name='journal-content'
      as='textarea'
      placeholder='Write in your Remble journal and save all your thoughts and ideas in one place'
      rows='14'
      defaultValue={value}
      ref={journalContent}
      required
      onChange={handleTextAreaChange}
    />
  )
}
